import PropTypes from 'prop-types';
import BasePrintModalA4 from './BasePrintModalA4';
import BasePrintModalA5 from './BasePrintModalA5';
import BasePrintModalThermal from './BasePrintModalThermal';

export default function UniversalPrintModal({ isThermalPrint, isA5Print, children, ...props }) {
  if (isThermalPrint) {
    return <BasePrintModalThermal {...props}>{children}</BasePrintModalThermal>;
  }
  if (isA5Print) {
    return <BasePrintModalA5 {...props}>{children}</BasePrintModalA5>;
  }
  return <BasePrintModalA4 {...props}>{children}</BasePrintModalA4>;
}

UniversalPrintModal.propTypes = {
  isThermalPrint: PropTypes.bool,
  isA5Print: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};
